import {Component, OnInit} from '@angular/core';
import {StorageService} from '../../services/storage.service';
import {FederalizacaoService} from '../../services/federalizacao.service';
import * as moment from 'moment';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-federalizacao',
  templateUrl: './federalizacao.component.html',
  styleUrls: ['./federalizacao.component.scss'],
})
export class FederalizacaoComponent implements OnInit {
  config: any;
  carregando = true;
  list: any[];
  showModalAvisoAlerta: any = false;
  showModalIps: any = false;
  tituloAviso = 'Atenção!';
  tituloIps = 'Detalhamento - IPs';
  ips = [];
  textoAviso = `
  <b>Como Funciona a Secret Key?</b><br><br>
  A chave tem validade de 90 dias, sendo que uma nova é gerada a cada 80 dias. Após a criação da nova chave, a anterior poderá ser usada por mais 10 dias.<br><br>

  <b>Instrução sobre o uso dos dados</b><br><br>
  Use as informações da tabela para acessar seus arquivos na nuvem da AWS. Você precisará da AccessKey (chave de acesso), da SecretKey (senha) e da região onde os arquivos estão guardados. Essas informações podem ser usadas em aplicativos ou ferramentas da AWS para acessar e gerenciar seus dados. Se tiver dúvidas, consulte o suporte ou a
  <a href="https://docs.aws.amazon.com/s3/" target="_blank">documentação da AWS</a>.
`;
  constructor(
    private storage: StorageService,
    private router: Router,
    private route: ActivatedRoute,
    private federalizacaoService: FederalizacaoService,
    private toast: ToastrService,
  ) {
    this.config = JSON.parse(this.storage.getCurrentApp());
  }

  async ngOnInit() {
    await this.carregarDados();
  }

  private async carregarDados() {
    console.log('tentando carregar os dados -- Federalizacao');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    try {

      this.list = await this.federalizacaoService.get();
      this.carregando = false;
    } catch (e) {
      console.log('----------------------------->', e);
      if (e.error) {
        await this.router.navigateByUrl('/');
        this.toast.error('Ocorreu um erro, tente novamente mais tarde.');
      }
      this.carregando = false;
    }
  }

  getDate(date) {
    return moment(date).format('DD/MM/YYYY');
  }

  async toggleModalAvisoAlerta() {
    this.showModalAvisoAlerta = !this.showModalAvisoAlerta;
  }

  async toggleModalIps() {
    this.showModalIps = !this.showModalIps;
  }

  async openModalIps(ips){
    console.log(ips);
    this.ips = ips;
    this.showModalIps = !this.showModalIps;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/federalizacao/federalizacao.component.ts